// extracted by mini-css-extract-plugin
var _1 = "SettingsSubmitConfirmation-module__confirmation--hMkoN";
var _2 = "SettingsSubmitConfirmation-module__fadeOut--iXrML";
export { _1 as "confirmation", _2 as "fadeOut" }
